import axios from "axios";
import { USER_AUTH, USER_EMAIL } from "./constants";
import Cookies from "js-cookie";

const BASE_URL = "https://account.scaptcha.com/";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json; charset=utf-8",
};

const client = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers,
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Anything except 2XX goes to here
    const status = error.response?.status || 500;
    if (status === 401) {
      (window.location as string | Location) =
        window.location.protocol + "//" + window.location.host + "/login";
      Cookies.remove(USER_AUTH);
      Cookies.remove(USER_EMAIL);
    } else if (error.request) {
      const message = JSON.parse(error.request.response);
      alert(message.msg);
    } else {
      return Promise.reject(error); // Delegate error to calling side
    }
  }
);

export const request = async ({ ...options }) => {
  const onSuccess = (response: any) => response;
  const onError = (error: any) => {
    return error;
  };

  try {
    const response = await client(options);
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
};
